import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import {
  Feature,
  FeatureNames,
  HolidayProgramCommands,
  HolidayProgramProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore, Platform } from '@store';

import { HolidayModeData } from '../holiday-mode-datepicker/holiday-mode-datepicker.component';
import { HolidayProgramType } from '../holiday-mode-select/holiday-mode-select.component';

@Component({
  selector: 'app-holiday-datepicker-modal',
  templateUrl: './holiday-datepicker-modal.component.html',
  styleUrls: ['./holiday-datepicker-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HolidayDatepickerModalComponent implements OnInit {
  readonly holidayProgramType = HolidayProgramType;

  holidayAtHome$: Observable<Feature<HolidayProgramProperties, HolidayProgramCommands>>;
  selectedHolidayType: HolidayProgramType;

  constructor(
    public dialogRef: MatDialogRef<HolidayDatepickerModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      startDate: Date;
      endDate: Date;
      minDaysDifference: number;
      circuitId: string;
      holidayType: HolidayProgramType;
      isMultiFamily: boolean;
      platform: Platform;
    },
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.selectedHolidayType = this.data.holidayType;

    this.holidayAtHome$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      this.data.isMultiFamily
        ? FeatureNames.circuitHolidayAtHome(this.data.circuitId)
        : FeatureNames.circuitSingleFamilyHolidayAtHome
    );
  }

  onSubmit(data: HolidayModeData): void {
    this.dialogRef.close({ selectedHolidayType: this.selectedHolidayType, ...data });
  }

  goToNextStage(selectedHolidayType: HolidayProgramType): void {
    this.selectedHolidayType = selectedHolidayType;
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
